// extracted by mini-css-extract-plugin
module.exports = {"votingBtn":"ThumbsUpButton_votingBtn__3O3PZ","up":"ThumbsUpButton_up__2B7ip","down":"ThumbsUpButton_down__Y4QDr"};